import { supabase } from "../supabase";

interface EntryMediaRow {
  diary_entry_id: string;
  media_id: string;
}

/** エントリーIDごとの結び付けたメディアID。表示側でサムネイルを引くのに使う */
export async function fetchEntryMediaIds(): Promise<Map<string, string[]>> {
  const { data, error } = await supabase
    .from("diary_entry_media")
    .select("diary_entry_id, media_id");
  if (error) throw error;
  const rows: EntryMediaRow[] = data;
  const map = new Map<string, string[]>();
  for (const row of rows) {
    const list = map.get(row.diary_entry_id) ?? [];
    list.push(row.media_id);
    map.set(row.diary_entry_id, list);
  }
  return map;
}

/**
 * アルバムにある写真・動画をエントリーに結び付ける。
 *
 * 日記からのアップロードは行わない。アルバムに入っているものを指すだけなので、
 * 外しても media 側は消えない(結び付きの行が消えるだけ)。
 */
export async function linkEntryMedia(entryId: string, mediaIds: string[]): Promise<void> {
  if (mediaIds.length === 0) return;
  const { error } = await supabase
    .from("diary_entry_media")
    .insert(mediaIds.map((mediaId) => ({ diary_entry_id: entryId, media_id: mediaId })));
  if (error) throw error;
}

/**
 * 結び付けを選び直した状態に合わせる。増えたぶんだけ足し、外したぶんだけ消す。
 *
 * 全消し→入れ直しにしないのは、途中で失敗したときに元々あった結び付きまで
 * 失われるため。差分だけなら、失敗しても触っていないものは残る。
 */
export async function updateEntryMedia(
  entryId: string,
  before: string[],
  after: string[],
): Promise<void> {
  const removed = before.filter((id) => !after.includes(id));
  if (removed.length > 0) {
    const { error } = await supabase
      .from("diary_entry_media")
      .delete()
      .eq("diary_entry_id", entryId)
      .in("media_id", removed);
    if (error) throw error;
  }
  await linkEntryMedia(
    entryId,
    after.filter((id) => !before.includes(id)),
  );
}
